import { Link } from 'react-router-dom';
import {
	FaPhoneAlt,
	FaFacebook,
	FaInstagram,
	FaPinterest,
	FaLinkedin,
	FaYoutube,
	FaRegEnvelope,
	FaGithub	 
} from "react-icons/fa";

const Footer = () => {
	return (
		<div className='container-footer'>
			<div className='footer-dividers'>
				<div className='footer-contact'>
					<h4 className='contact-title-footer'>CONTÁCTANOS</h4>
					<p className='contact-text'><FaRegEnvelope />veronicavegaabogada@gmail.com</p>
					<p className='contact-text'><FaPhoneAlt />+54 9 11 6218-0101</p>
				</div>
				<div className='container-privacy'>
					<Link to='/' style={{textDecoration:'none'}} className='privacy-links'>Inicio</Link>
					<Link to='/#about' style={{textDecoration:'none'}} className='privacy-links'>Sobre Mí</Link>
					<Link to='/#practice' style={{textDecoration:'none'}} className='privacy-links'>Áreas de Práctica</Link>
					<Link to='/#contact' style={{textDecoration:'none'}} className='privacy-links'>Contacto</Link>
				</div>
				<div className='container-privacy'>
					<Link to='/privacy-policies' style={{textDecoration:'none'}} className='privacy-links'>Política de Privacidad</Link>
					<Link to='/cookies-policies' style={{textDecoration:'none'}} className='privacy-links'>Política de Cookies</Link>
					<Link to='/frecuent-questions' style={{textDecoration:'none'}} className='privacy-links'>Preguntas Frecuentes</Link>
				</div>
				<div className='footer-social-media'>
					<Link to='https://www.facebook.com/veronicavegaabogada' className='contain-social-btn facebook' target='_blank' style={{textDecoration:'none'}}>
						<FaFacebook className='social-btn-icon' />
					</Link>
					<Link to='https://www.instagram.com/veronica_vega_abogada/' className='contain-social-btn instagram' target='_blank' style={{textDecoration:'none'}}>
						<FaInstagram className='social-btn-icon' />
					</Link>
				</div>
			</div>
			<div className='footer-copy-media'>
				<p className='container-rights'>Verónica Vega {new Date().getFullYear()} &copy; Todos los Derechos Reservados | Imágenes by Freepik</p>
				<p className='container-rights'>Elaborado por <Link to='https://www.instagram.com/kching_ar/' className='elaborated-link' target='_blank' style={{textDecoration:'none'}}>K-Ching</Link></p>
			</div>
		</div>
	);
};

export default Footer;